// =============================================================================
// LABELS CONFIGURATION - Powered by i18n
// =============================================================================
// Questo file fornisce accesso rapido alle etichette delle entità
// tramite il sistema i18n. L'oggetto L è un proxy che legge
// i valori dalle traduzioni correnti.
// =============================================================================

import i18n from '../i18n';

function t(key: string): string {
  return i18n.t(key, { ns: 'common' });
}

// Proxy dinamico che legge sempre la traduzione corrente
export const L = new Proxy({} as Record<string, string>, {
  get(_target, prop: string) {
    return t(`entities.${prop}`);
  },
}) as {
  readonly customer: string;
  readonly customers: string;
  readonly service: string;
  readonly services: string;
  readonly resource: string;
  readonly resources: string;
  readonly location: string;
  readonly locations: string;
  readonly appointment: string;
  readonly appointments: string;
  readonly resourceType: string;
  readonly resourceTypes: string;
  readonly organization: string;
  readonly organizations: string;
};

// Tipo per TypeScript
export type LabelKey = keyof typeof L;
